<template>
    <div class="form-group select form-group-floating-label">
        <select
            :id="phaseName"
            v-model="company"
            class="form-input"
            :name="phaseName"
        >
            <option :value="null">Alla</option>
            <option
                v-for="(id, name) in options"
                :key="`${phaseName}_${id}`"
                :value="id"
            >
                {{ name }}
            </option>
        </select>

        <label class="floating-label">
            Tilldelad entreprenör {{ label }}
        </label>

        <select-arrow />
    </div>
</template>

<script>
    export default {
        props: {
            phase: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: true,
            },
            initialCompany: {
                type: [String, Number],
                default: null,
            },
            options: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                company: null,
            };
        },
        computed: {
            phaseName() {
                return `${this.phase}_phase_company_id`;
            },
        },
        mounted() {
            this.company = this.initialCompany;
        },
    };
</script>
